import { Component } from '../../../libs/gin-tonic/helpers/compiler';
import { getParentWithClass } from '../../../libs/gin-tonic/helpers/dom/get-parent-with-class';

@Component({ className: 'js-multi-filter' })
export class MultiFilterComponent {
	private overlay: HTMLElement;
	private button: HTMLElement;
	private optionsContainer: HTMLElement;
	private parentClass = "js-multi-filter-parent";
	private resetSelector = ".js-multi-filter-reset";
	private activeOptionSelector = ".mixitup-control-active";

	constructor(private element: HTMLElement) {
		this.overlay = document.querySelector<HTMLElement>('.js-multi-filter-overlay');
		this.button = this.element.querySelector<HTMLElement>('.js-multi-filter-button');
		this.optionsContainer = this.element.querySelector<HTMLElement>('.js-multi-filter-options-container');
		const parent = getParentWithClass(this.element, this.parentClass);
		if (parent) {
			parent.querySelectorAll(this.resetSelector).forEach(btn => btn.addEventListener('click', () => setTimeout(this.setButtonState, 100)))
		}

		// this.optionsContainer.addEventListener('click', () => setTimeout(this.setButtonState, 100));
		this.button?.addEventListener('click', this.open);
		this.overlay?.addEventListener('click', this.close);
	}

	setButtonState = () => {
		console.log("setState");
		const activeItems = this.optionsContainer.querySelectorAll(this.activeOptionSelector);
		this.button.classList.toggle('is-active', activeItems.length > 0)
	}

	open = () => {
		console.log("open");
		
		this.overlay?.classList.add('is-showing');
		this.button?.classList.add('is-open');
		this.optionsContainer?.classList.add('is-visible');
	}

	close = () => {
		console.log("close");
		this.overlay?.classList.remove('is-showing');
		this.button?.classList.remove('is-open');
		this.optionsContainer?.classList.remove('is-visible');
	}
}
